import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    CardContent,
    Chip,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Menu,
    MenuItem,
    TextField,
    Typography
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LoopIcon from '@material-ui/icons/Loop';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import InfoCard from './InfoCard';
import { getAots, pdfPreview } from '../api';

const Aot = ({ market, merchants, aot, setAot, setMerchants, merchantCount }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [aots, setAots] = useState([]);

    const removeMerchant = merchant => {
        if (window.confirm(`Enlever ${merchant.raisonSociale} de la liste ?`)) {
            setMerchants(merchant);
        }
    };

    useEffect(() => {
        getAots()
            .then(res => setAots(res.data.filter(a => a.deleted_at === null)))
            .catch(err => alert(err));
    }, []);

    return (
        <Grid
            container
            direction="row"
            alignContent="center"
            justifyContent="center"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" color="initial">
                    Marché
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <InfoCard market={market} merchants={merchants} merchantCount={merchantCount} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="initial">
                    Autorisation d'occupation temporaire du domaine public
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Card elevation={1}>
                    <div style={{ padding: '18px 24px', borderBottom: '1px solid #eee' }}>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            justify="space-between">
                            <Typography variant="body1" color="primary">
                                {aot.label}
                            </Typography>
                            {aots.length > 1 ? (
                                <>
                                    <Chip
                                        icon={<LoopIcon />}
                                        size="small"
                                        label="Sélectionner une autre AOT"
                                        clickable
                                        color="primary"
                                        onClick={event => setAnchorEl(event.currentTarget)}
                                    />
                                    <Menu
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={anchorEl !== null}
                                        onClose={() => setAnchorEl(null)}>
                                        {aots
                                            .filter(a => a.id !== aot.id)
                                            .map(a => (
                                                <MenuItem
                                                    key={a.id}
                                                    onClick={() => setAot(a) || setAnchorEl(null)}>
                                                    {a.label}
                                                </MenuItem>
                                            ))}
                                    </Menu>{' '}
                                </>
                            ) : null}
                        </Grid>
                    </div>
                    <CardContent>
                        <TextField
                            fullWidth
                            multiline
                            rows={20}
                            value={aot.text}
                            variant="standard"
                            InputProps={{
                                readOnly: true,
                                style: { padding: 0 }
                            }}
                        />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="initial">
                    Titulaires sélectionnés
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Card elevation={1}>
                    <CardContent style={{ padding: 0 }}>
                        <List dense>
                            {merchants.map(merchant => (
                                <ListItem key={merchant.id} divider dense>
                                    <ListItemText
                                        id={merchant.id}
                                        primary={
                                            <Typography variant="body1">
                                                {merchant.raisonSociale}
                                            </Typography>
                                        }
                                    />
                                    <ListItemSecondaryAction>
                                        <Button
                                            color="primary"
                                            onClick={() =>
                                                pdfPreview(merchant.id, market.id, aot.id)
                                            }
                                            size="small"
                                            startIcon={<VisibilityIcon />}>
                                            Aperçu
                                        </Button>
                                        {merchants.length > 1 ? (
                                            <IconButton
                                                size="small"
                                                style={{ color: 'red' }}
                                                onClick={() => removeMerchant(merchant)}>
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        ) : null}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Aot;
